<template>
  <div class="subcontainer" v-if="notification">
    <button id="notificationBanner" v-on:click="toggleNotification" type="button" class="collapsible active">
      {{ header }}
    </button>
    <div class="content">
      <div v-html=sanitizeHtml(notification) />
    </div>
  </div>
</template>

<script>
  import DOMPurify from 'dompurify';

	export default {
		props: {
      header: String,
			notification: String
		},
    methods: {
      sanitizeHtml(message) {
        const allowedTags= ['h1','h2','h3','h4','h5','h6','b','i','em','strong','s','sup','sub','p','br','hr','div','span'];
        return DOMPurify.sanitize(message, {ALLOWED_TAGS: allowedTags, ALLOWED_ATTR: []});
      },
      toggleNotification(event) {
        if (event) {
          event.target.classList.toggle("active");
          var content = event.target.nextElementSibling;
          if (content.style.display === "none") {
            content.style.display = "block";
          } else {
            content.style.display = "none";
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
    .subcontainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
    }
    .collapsible {
      width: 100%;
      text-align: left;
      font-size: 15px;
      margin-left: 0px;
    }
    .content {
      padding: 0 18px;
      overflow: hidden;
      background-color: #cce5ff;
      border-color: #b8daff;
    }
    .collapsible:after {
      content: '\002B'; /* Unicode character for "plus" sign (+) */
      color: transparent;
      text-shadow: 0 0 0 white;
      font-size: 18px;
      float: right;
    }
    .active:after {
      content: "\2212"; /* Unicode character for "minus" sign (-) */
    }
</style>